import { Table } from '@dreamtree-org/twreact-ui';

/**
 * twreact Table with console defaults: no serial/action/column-picker chrome,
 * toolbar only when searching. Every prop can still be overridden.
 * Below 768px the Table renders mobile cards on its own.
 */
export default function DataTable({ globalSearch = false, ...props }) {
  return (
    <Table
      withAction={false}
      showSerial={false}
      showColumnPicker={false}
      showReloadButton={false}
      showLimitSelector={false}
      stripedRows={false}
      showToolbar={globalSearch}
      globalSearch={globalSearch}
      {...props}
    />
  );
}
